"use client";
import * as TrackerModule from "@/tracker";
import { usePathname } from "next/navigation";
import { useEffect, useMemo } from "react";

export default function TrackerComponent() {
  // Be resilient to ESM/CJS interop differences in production bundles.
  const tracker = useMemo(() => {
    const m: any = TrackerModule as any;
    return (m && (m.tracker ?? m.default ?? m)) as any;
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!tracker) return;
    if (tracker.initiated) return;

    // if localstorage has key "env" set to "dev", set dev mode
    const env = localStorage.getItem("env");
    console.log("env", env);
    if (typeof tracker.init === "function") {
      tracker.init("knihovna-ai-site", env === "dev", false);
    }
  }, [tracker]);

  const pathname = usePathname();

  useEffect(() => {
    if (!tracker) return;
    if (typeof tracker.send !== "function") return;
    tracker.send("pageview");
  }, [pathname, tracker]);

  return null;
}
